import { useState, useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import { useStore } from "../store/store";
import { GmContext } from "../pages/Main";
// import myImage from '../../assets/image.png';

export default function TopPanel() {
  const { activeMode, setActiveMode, setShowGallery } = useStore();
  const { gameManager } = useContext(GmContext);

  return (
    <WrapperNav>

      <ItemWrapper >
        <img style={{ width: "24px" }} src={`/left-click.png`} alt=" " />
        <Title>
          Left click and drag to rotate camera
        </Title>
      </ItemWrapper>

      <ItemWrapper onClick={() => {
        if (activeMode !== "Normal") {
          gameManager.studioSceneManager.activeNormalView();
          setActiveMode("Normal");
        }
      }}>
        <img style={{ width: "24px" }} src={`/reset.png`} alt=" " />
        <Title>
          Reset
        </Title>
      </ItemWrapper>

    </WrapperNav>
  );
}

const WrapperNav = styled.nav`
  bottom: 0;
  position:fixed;
  display: flex;
  width: 40vw;
  padding: 4px 5px;
  justify-content: flex-start;
  background-color: #fad09a;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px 20px 0px 0px;
`;
// color: ${props => props.theme.main};



const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Title = styled.text`
  font-size: 0.9em;
  text-align: center;
  color: black;
  margin-left: 10px;
`;